import { db } from '../firebase';
import { collection, getDocs, getDoc, doc, addDoc, updateDoc, deleteDoc } from 'firebase/firestore';
import { Playlist, Song } from '../types';
import { getSongById } from './songService';

export const getPlaylists = async (): Promise<Playlist[]> => {
  const playlistsCollection = collection(db, 'playlists');
  const playlistsSnapshot = await getDocs(playlistsCollection);
  return playlistsSnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
    createdAt: doc.data().createdAt?.toDate(),
    updatedAt: doc.data().updatedAt?.toDate()
  } as Playlist));
};

export const getPlaylistById = async (id: string): Promise<Playlist | null> => {
  const playlistDoc = doc(db, 'playlists', id);
  const playlistSnapshot = await getDoc(playlistDoc);
  
  if (!playlistSnapshot.exists()) return null;
  
  return {
    id: playlistSnapshot.id,
    ...playlistSnapshot.data(),
    createdAt: playlistSnapshot.data().createdAt?.toDate(),
    updatedAt: playlistSnapshot.data().updatedAt?.toDate()
  } as Playlist;
};

export const createPlaylist = async (name: string, songIds: string[] = []): Promise<Playlist> => {
  const now = new Date();
  const newPlaylist = {
    name,
    songIds,
    createdAt: now,
    updatedAt: now
  };
  
  const docRef = await addDoc(collection(db, 'playlists'), newPlaylist);
  
  return {
    id: docRef.id,
    ...newPlaylist
  } as Playlist;
};

export const updatePlaylist = async (id: string, updates: Partial<Playlist>): Promise<void> => {
  const playlistRef = doc(db, 'playlists', id);
  await updateDoc(playlistRef, {
    ...updates,
    updatedAt: new Date()
  });
};

export const deletePlaylist = async (id: string): Promise<void> => {
  await deleteDoc(doc(db, 'playlists', id));
};

// Helper function to get all songs in a playlist
export const getPlaylistSongs = async (playlistId: string): Promise<Song[]> => {
  const playlist = await getPlaylistById(playlistId);
  if (!playlist) return [];
  
  const songs: Song[] = [];
  
  for (const songId of playlist.songIds) {
    const song = await getSongById(songId);
    if (song) songs.push(song);
  }
  
  return songs;
}; 